exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.arrow-square[data-v-df104126],ul.arrow[data-v-df104126],ul.check-circle[data-v-df104126],ul.check-square[data-v-df104126],ul.check[data-v-df104126],ul.chevron[data-v-df104126],ul.circle[data-v-df104126],ul.decimal[data-v-df104126],ul.lower-latin[data-v-df104126],ul.triangle[data-v-df104126],ul.upper-latin[data-v-df104126],ul.upper-roman[data-v-df104126]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-df104126]{font-size:1.6em}.booking-information[data-v-df104126]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-df104126","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/luggage/Home.vue
// module id = 570
// module chunks = 0